const $ = require('jquery');

// google autocomplete script for location

// check if google is defined because script is not loaded on every page
if (typeof google !== 'undefined') {

    // variable to check if autocomplete is initialized
    let sessionToken = new google.maps.places.AutocompleteSessionToken(),
    autocompleteService = new google.maps.places.AutocompleteService(),
    $autoComplete = $('#autocomplete'),
    $locationResults = $('.autocomplete-results'),
    $trigger = $('.trigger-autocomplete'),
    $remove = $('.remove-autocomplete'); 

    // hide remove on load
    $remove.hide(); 

    // set global options variable for autocomplete
    let options = {
        componentRestrictions: { country: "nl" },
        sessionToken: sessionToken, 
        types: ['(cities)']
    };

    $autoComplete.on('keyup', function() {
        
        // user input value
        let input = $(this).val(); 

        // check input length
        if (input.length < 3) {

            // hide results container 
            if ($locationResults.is(':visible')) {
               $locationResults.hide(); 
            }

            // replace autocomplete remove with autocomplete trigger
            if ($remove.is(':visible')) {
                $trigger.show();
                $remove.hide();
            }

        } else {
            // initialize google maps places autocomplete predicitions

            // assign user input to options
            options.input = input; 

            let predictions = autocompleteService.getPlacePredictions(options, function(results, status) {
                
                // check if status is ok
                if (status === 'OK') {
                    // add results to resultcontainer
                    let resultHtml = '';

                    // construct html for each result
                    results.forEach(function(result, index) {
                        resultHtml += '<div class="result" data-place-id="'+ result.place_id +'" data-index="'+ index +'">';
                        resultHtml += '<label class="result-main">' + result.structured_formatting.main_text+'';
                        //resultHtml += '<span class="result-secondary">'+ result.structured_formatting.secondary_text +'</span>';
                        resultHtml += '</label>';
                        resultHtml += '</div>';  
                    });

                    // add google attribution to results container
                    resultHtml += '<div class="autocomplete-attribution"><div class="powered-by-google"></div></div>';

                    // show results
                    $locationResults.html(resultHtml).show(); 

                    // replace autocomplete trigger with autocomplete remove
                    if ($trigger.is(':visible')) {
                        $trigger.hide();
                        $remove.show();
                    }
                }
            });
        }
    }); 

    // assign clicked location result to input value
    $locationResults.on('click', function(e){

        let $result = $(e.target).closest('.result'); 

        if ($result.length) {
            let value = $result.find('.result-main').html();
            $autoComplete.val(value); 
            $autoComplete[0].setSelectionRange(value.length, value.length);
            $autoComplete.focus(); 

            // hide location results
            $locationResults.hide(); 
        }
    });

    // hide autocomplete results when user clicks outside autocomplete container
    $(document).on('click', function (e) {
        // close modals when clicking outside window
        if (!$(e.target).closest($locationResults).length > 0) {
            if ($locationResults.is(':visible')) {
                $locationResults.hide(); 
            }
        }
    });

    // remove user input from autocomplete text field
    $remove.on('click', function() {
        $autoComplete.val('');

        // replace autocomplete remove with autocomplete trigger
        if ($remove.is(':visible')) {
            $trigger.show();
            $remove.hide();
        }
    });
}

